export default class BrandQuery {
	id: string;

	currency: string | null;

	constructor(id: string, currency: string | null) {
		this.id = id;
		this.currency = currency;
	}

	get key(): string {
		return `${this.id}-${this.currency ?? ''}`;
	}

	get isValid(): boolean {
		return true;
	}
}
